import { render, staticRenderFns } from "./QuestionDialog.vue?vue&type=template&id=1e122624&scoped=true&lang=pug&"
import script from "./QuestionDialog.vue?vue&type=script&lang=ts&"
export * from "./QuestionDialog.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionDialog.vue?vue&type=style&index=0&id=1e122624&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e122624",
  null
  
)

export default component.exports